import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIconfinderComponent } from './simple-icons-iconfinder.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIconfinderComponent ],
    exports:      [ SimpleIconsIconfinderComponent ],
    bootstrap:    []
})
export class SimpleIconsIconfinderModule {}
